export default __webpack_public_path__ + "static/media/Purple geode_primary.50765917.jpg";